import { render } from "./ContactListScroll.vue?vue&type=template&id=72307348&scoped=true"
import script from "./ContactListScroll.vue?vue&type=script&lang=ts"
export * from "./ContactListScroll.vue?vue&type=script&lang=ts"

import "./ContactListScroll.vue?vue&type=style&index=0&id=72307348&scoped=true&lang=scss"
import "./ContactListScroll.vue?vue&type=style&index=1&id=72307348&lang=scss"
script.render = render
script.__scopeId = "data-v-72307348"

export default script